import axios, { AxiosInstance } from 'axios';
import { Token } from './api';
import getBasicToken from './getBasicToken';
import TokenManager from './tokenManager';

class TokenManagerInstance extends TokenManager {
  readonly prefix: string;
  readonly baseUrl: string;
  readonly refreshUrl?: string;

  constructor({
    prefix,
    baseUrl,
    refreshUrl,
  }: {
    prefix: string;
    baseUrl: string;
    refreshUrl?: string;
  }) {
    super(prefix);
    this.prefix = prefix;
    this.baseUrl = baseUrl;
    this.refreshUrl = refreshUrl;
  }

  async instance(token?: string): Promise<AxiosInstance> {
    const headers = {
      Authorization: token || (await this.getAuthorization()),
    };

    return axios.create({
      baseURL:
        process.env.NODE_ENV === 'production'
          ? this.baseUrl
          : `/api-${this.prefix}`,
      headers,
      withCredentials: true,
    });
  }

  async getAuthorization() {
    let accessToken = super.getAccessToken();

    if (!super.getRefreshToken()) {
      return `Basic ${getBasicToken()}`;
    }

    if (!accessToken || super.isExpired(accessToken)) {
      const refreshedToken = await this.refreshToken();
      accessToken = refreshedToken.accessToken;
    }

    return `Bearer ${accessToken}`;
  }

  private async refreshToken(): Promise<Token> {
    const refreshToken = super.getRefreshToken();

    const instance = await this.instance(`Basic ${getBasicToken()}`);
    const { data } = await instance.post(this.refreshUrl || '/v1/auth/token', {
      refreshToken,
    });

    const newToken = this.refreshUrl ? data.result : data.data.token;

    super.save(newToken);

    return newToken;
  }
}

export default TokenManagerInstance;
